import { App } from "../app/app";
import "../styles.css";

export async function bootstrap(): Promise<void> {
  const root = document.querySelector<HTMLElement>("#app");
  if (!root) throw new Error("#app root is missing");
  const devMode = import.meta.env.DEV;
  const app = new App(root, devMode);
  await app.boot();
}
